import { BookingForm } from '../../common/AnalyticsContext/TrackingData';
import { BookingFormClient } from './useDisplayAppointment';

export const useBookingForm = (bookingFormClient: BookingFormClient): BookingForm => {
  switch (bookingFormClient) {
    case 'book_mobile':
    case 'book_iphone':
      return BookingForm.IPHONE;
    case 'book_android':
      return BookingForm.ANDROID;
    case 'book_widget':
    case 'book_webplugin':
    case 'book_practice':
      return BookingForm.WIDGET;
    case 'book_as_practice':
      return BookingForm.PRACTICE;
    default:
      return BookingForm.WEBSITE;
  }
};
